module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'imgHotzone') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.title),
      callback: function($$v) {
        _vm.$set(_vm.base, "title", $$v)
      },
      expression: "base.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.base, "subtitle", $$v)
      },
      expression: "base.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图"
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.config.imgUrl) ? _c('img', {
    staticClass: "banner-uploader",
    attrs: {
      "src": _vm.wximageurl + _vm.config.imgUrl
    },
    on: {
      "click": _vm.handleImgChange
    }
  }) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": _vm.handleImgChange
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n          ")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "热区"
    }
  }, [_c('hotzone', {
    staticClass: "hotzone",
    attrs: {
      "image": _vm.config.imgUrl,
      "zonesInit": _vm.data
    },
    on: {
      "add": _vm.handleAdd,
      "change": _vm.handleChange,
      "remove": _vm.handleRemove
    }
  }), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      staticClass: "setting-item slider"
    }, [_c('div', {
      staticClass: "uploader-setting"
    }, [_c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }, [(item.id) ? _c('div', {
      staticClass: "link-content"
    }, [(item.linkPage === 'goods') ? [_vm._v("商品：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'category') ? [_vm._v("分类：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'article') ? [_vm._v("文章：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'planting') ? [_vm._v("软文：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'link') ? [_vm._v("页面：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'marketing') ? [_vm._v("营销：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'custom_page') ? [_vm._v("自定义页面：")] : _vm._e(), _vm._v("\n                " + _vm._s(item.title) + "\n              ")], 2) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }), _vm._v("设置路径")])])])])
  })], 2)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2fd2d00e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fd2d00e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/img_hotzone.vue
// module id = 2590
// module chunks = 0